import { Menu, Item } from 'react-contexify'
import { TriggerEvent } from 'react-contexify/lib/types'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useSelector } from 'react-redux'
import { useCommentsContext } from '@templates/approval/contexts'
import { ActionType } from '@templates/approval/contexts/commentsContext/types'
import { t } from '@lingui/core/macro'
import { RootState } from '@redux/store'

interface Props {
  data: any
  menuId: string
  cellData: any
  column: any
}

function checkIsLocked(column) {
  if (!column) return

  const { governanceType, visible } = column

  return (
    [
      'autofill',
      'autonumber',
      'concatenation',
      'constant',
      'custom-bitlink',
      'cv_id',
      'deep-link',
      'pattern',
      'qr-code',
      'random',
      'shortened link',
    ].includes(governanceType) || !visible
  )
}

export const ApprovalContextMenu = ({ data, menuId, cellData, column }: Props) => {
  const user = useSelector((state: RootState) => state.Auth.user)
  const { dispatch } = useCommentsContext()

  const cellValue = cellData?.value
  const cellHasNoComments = !cellData?.comment
  const allowComments = Boolean(data[1]?.data[column?.fieldId])
  const isLocked = checkIsLocked(column)

  return (
    <Menu id={menuId}>
      <CopyToClipboard text={cellValue}>
        <Item>{t`Copy cell value`}</Item>
      </CopyToClipboard>
      {allowComments && cellHasNoComments && !isLocked && (
        <Item onClick={handleOpenCommentDialog}>{t`Add comment`}</Item>
      )}
    </Menu>
  )

  /**
   * Opens the comment dialog and updates the currentCommentDetails with the
   * data needed to add a comment to dataset rows.
   *
   * @param {TriggerEvent} event
   */
  function handleOpenCommentDialog({ event }: { event: TriggerEvent }) {
    const rowNum = getRowNum(event.target)
    const rowIdx = rowNum + 1
    const cvId = data[rowIdx]?.cvid

    dispatch({
      type: ActionType.setCommentDialogOpen,
      payload: true,
    })

    dispatch({
      type: ActionType.setCurrentCommentDetails,
      payload: {
        cvId,
        rowIdx: rowNum,
        fieldId: column.fieldId,
        commenter: user,
      },
    })
  }

  /**
   * Retrieves the data-row attribute from the clicked cell
   */
  function getRowNum(target) {
    return +target.closest('.read-grid-cell')?.getAttribute('data-row') - 1
  }
}
